import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const LOCATION_DISTANCE_SCHEMA = Object.freeze({
  VALUE: 0,
  FORMATTED: '',
});
const RECORD = generateSchema(LOCATION_DISTANCE_SCHEMA);
const KEYS: any = generateKeys(LOCATION_DISTANCE_SCHEMA);

export class LocationDistance extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }
}
